import {createSvgIcon} from "@mui/material";

const GanttIcon = createSvgIcon(
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
    <path
      d="M9.57895 2.75V6.30556H2V2.75H9.57895ZM12.9474 15.1944V18.75H2V15.1944H12.9474ZM18 8.97222V12.5278H2V8.97222H18Z"
      fill="currentColor"
    />
  </svg>,
  "GanttIcon",
);

export {GanttIcon};
